import Long from 'long'
import Storage from "@/uitls/Storage";

export default class IMUtils {


  //生成chatkey
  static createChatKey(tauid: number) {
    const myuid = Storage.get('uid');
    if (tauid < myuid) {
      return Long.fromValue(tauid * Math.pow(2, 32)).add(Long.fromValue(myuid));
    } else {
      return Long.fromValue(tauid).add(Long.fromValue(myuid * Math.pow(2, 32)));
    }
  }

  static isGroup(chatkey) {
    return chatkey < 2147483647;
  }

  static longtoNmber(chatkey: Long) {
    return chatkey.toNumber()
  }

  //解析chatkey 
  static decodeChatkey(chatkey: string) {


    const myuid = Storage.get('uid');
    let enChatkey = Long.fromValue(chatkey);

    if (enChatkey.high == 0) {
      return enChatkey.low
    }
    if (enChatkey.high == myuid) {
      return enChatkey.low;
    } else {
      return enChatkey.high
    }
  }

  static fromString(unicode) {
    // const uint8Array = new Uint8Array(unicode.length);
    // for (let i = 0; i < unicode.length; i++) {
    //   uint8Array[i] = unicode.charCodeAt(i);
    // }
    // return uint8Array;
    return new TextEncoder().encode(unicode);
  }
  static encode(str) {
    const code = encodeURIComponent(str);
    const arr = [];
    for (let i = 0; i < code.length; i++) {
      const c = code.charAt(i);
      if (c === "%") {
        const hex = code.charAt(i + 1) + code.charAt(i + 2);
        const hexVal = parseInt(hex, 16);
        arr.push(hexVal);
        i += 2;
      } else {
        arr.push(c.charCodeAt(0));
      }
    }
    return new Uint8Array(arr);
  }
  static decode(arr) {
    let encoded = "";
    for (let i = 0; i < arr.length; i++) {
      let s = arr[i] < 16 ? "%0" : "%";
      encoded += s + arr[i].toString(16);
    }
    try {
      return decodeURIComponent(encoded);
    } catch (e) {
      return this.decode1(arr);
    }
  }

  static decode1(array) {
    let out, i, len, c;
    let char2, char3;

    out = "";
    len = array.length;
    i = 0;
    while (i < len) {
      c = array[i++];
      switch (c >> 4) {
        case 0:
        case 1:
        case 2:
        case 3:
        case 4:
        case 5:
        case 6:
        case 7:
          // 0xxxxxxx
          out += String.fromCharCode(c);
          break;
        case 12:
        case 13:
          // 110x xxxx   10xx xxxx
          char2 = array[i++];
          out += String.fromCharCode(((c & 0x1f) << 6) | (char2 & 0x3f));
          break;
        case 14:
          // 1110 xxxx  10xx xxxx  10xx xxxx
          char2 = array[i++];
          char3 = array[i++];
          out += String.fromCharCode(
            ((c & 0x0f) << 12) | ((char2 & 0x3f) << 6) | ((char3 & 0x3f) << 0)
          );
          break;
      }
    }
    return out;
  }

  static getHm() {
    const now = new Date();
    let h = now.getHours() * 60;
    let m = now.getMinutes();
    return h + m;
  }

  static intToTime(mm: number) {
    const h = Math.floor(mm / 60);
    const s = mm % 60;
    return IMUtils.timeCheck(h) + ":" + IMUtils.timeCheck(s);
  }

  static timeCheck(val: number) {
    return val < 10 ? "0" + val : val.toString();
  }
}

